<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Store
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="3">
              <v-text-field
                v-model="form.gst_no"
                outlined
                label="GST Number"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.gst_no"
              ></v-text-field>
              <!-- <v-text-field
                v-model="data.id_number"
                outlined
                label="GST Number"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.id_number"
              ></v-text-field> -->
            </v-col>
            <!-- <v-col sm="4">
              <v-autocomplete
                ref="user"
                outlined
                v-model="form.state_id"
                :items="stateItems"
                label="States"
                prepend-inner-icon="mdi-account"
                clearable
                :error-messages="errors.state_id"
              ></v-autocomplete>
            </v-col> -->
            <v-col sm="3">
              <v-text-field
                v-model="form.business_name"
                outlined
                label="Business Name*"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.business_name"
              ></v-text-field>
            </v-col>
            <v-col sm="3">
              <v-autocomplete
                ref="store"
                outlined
                v-model="form.store_type"
                :items="statuses"
                label="Store"
                prepend-inner-icon="mdi-account"
                clearable
                :error-messages="errors.store_type"
              ></v-autocomplete>
            </v-col>
            <v-col sm="3">
              <v-text-field
                v-model="form.state_jurisdiction"
                outlined
                label="State Name*"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.state_jurisdiction"
              ></v-text-field>
            </v-col>
            <v-col sm="3">
              <v-autocomplete
                ref="city"
                outlined
                v-model="form.city"
                :items="cityItems"
                label="City*"
                prepend-inner-icon="mdi-account"
                clearable
                :error-messages="errors.city"
              ></v-autocomplete>
            </v-col>
            <v-col sm="3">
              <v-text-field
                v-model="form.pincode"
                outlined
                label="Pincode"
                prepend-inner-icon="mdi-mailbox"
                type="number"
                :error-messages="errors.pincode"
              ></v-text-field>
            </v-col>
            <v-col sm="3">
              <v-text-field
                v-model="form.store_location"
                outlined
                label="Location*"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.store_location"
              ></v-text-field>
            </v-col>
            <v-col sm="3">
              <v-text-field
                v-model="form.toll_free"
                outlined
                label="Toll Free Number"
                prepend-inner-icon="mdi-phone"
                :error-messages="errors.toll_free"
              ></v-text-field>
            </v-col>
            <v-col sm="3">
              <v-text-field
                v-model="form.email"
                outlined
                label="Email *"
                prepend-inner-icon="mdi-email"
                :error-messages="errors.email"
              ></v-text-field>
            </v-col>
            <v-col sm="3">
              <v-text-field
                v-model="form.store_code"
                outlined
                label="Store Code"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.store_code"
              ></v-text-field>
            </v-col>
            <v-col sm="3">
              <v-autocomplete
                outlined
                v-model="form.owner_id"
                :items="frachiseeItems"
                label="Franchisee"
                prepend-inner-icon="mdi-account"
                clearable
                :error-messages="errors.user_id"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row align="end">
            <v-col sm="5">
              <v-textarea
                v-model="form.address"
                outlined
                label="Address*"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.address"
              ></v-textarea>
            </v-col>
            <v-col sm="5" v-if="showNewAddress || form.new_address">
              <v-textarea
                v-model="form.new_address"
                outlined
                label="New Address*"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.new_address"
              ></v-textarea>
            </v-col>
            <v-col sm="2">
              <v-checkbox
                v-model="showNewAddress"
                label="Add New Address"
                class="mb-3"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <div>
            <span class="text-h6 ml-3">Add of Salesman</span>
          </div>
          <v-col sm="4">
            <v-autocomplete
              ref="user"
              outlined
              v-model="form.user_ids"
              :items="userItems"
              label="Users"
              multiple
              prepend-inner-icon="mdi-account"
              deletable-chips
              small-chips
              :error-messages="errors.user_id"
            ></v-autocomplete>
          </v-col>
          <v-col>
            <v-switch
              class="mt-0 ml-5"
              v-model="form.is_active"
              inset
              :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
            ></v-switch>
          </v-col>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Store
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "StoreEditPage",
  data() {
    return {
      data: {
        key: "133c4c48-e4cd-439a-a3c8-9a8a440390ff",
        id_number: "",
        filing_status_get: true,
      },
      form: {
        name: "",
        city: "",
        pincode: "",
        user_ids: [],
        state_id: "",
        is_active: false,
        // showNewAddress: this.form.new_address || false,
      },
      isLoading: false,
      userItems: [],
      frachiseeItems: [],
      cityItems: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "COMPANY OWNER", text: "COMPANY OWNER", value: 1 },
        { id: "FRANCHISEE", text: "FRANCHISEE", value: 2 },
      ],
      showNewAddress: false,
    };
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  watch: {
    "form.gst_no"(newVal) {
      // Check if GST number length is 15
      if (newVal.length === 15) {
        this.getGSTData(); // Call the get data function
      }
    },
    "form.store_type"(newStatus) {
      if (newStatus !== "your-allowed-status" && this.store_type == 2) {
        this.form.owner_id = "";
      }
    },
  },
  methods: {
    async getMasters() {
      await axios
        .get(`stores/masters`)
        .then((masters) => {
          masters = masters.data;
          //Users
          masters.users.forEach((user) => {
            this.userItems.push({
              id: user.id,
              text: user.user_name + " - " + user.phone,
              value: user.id,
            });
          });
          // Franchisee
          masters.franchisee.forEach((frachisee) => {
            this.frachiseeItems.push({
              id: frachisee.id,
              text: frachisee.user_name + "  -  " + frachisee.phone,
              value: frachisee.id,
            });
          });
          //State
          masters.states.forEach((state) => {
            this.stateItems.push({
              id: state.id,
              text: state.name,
              value: state.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
    },
    async getGSTData() {
      this.data.id_number = this.form.gst_no;
      console.log(this.data);
      await axios
        .post(`gst_data`, this.data)
        .then((response) => {
          let stores = response.data.data;
          let stateJurisdiction = stores.state_jurisdiction;
          this.form.business_name = stores.business_name;
          this.form.state_jurisdiction = stateJurisdiction
            .match(/^State - [^,]+/)[0]
            .split(" - ")[1];
          this.form.address = stores.address;
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
      this.getCityData();
    },
    async getCityData() {
      console.log("city", this.form.state_jurisdiction);
      const payload = {
        state: this.form.state_jurisdiction,
        country: "India",
      };
      console.log(payload);
      await axios
        .post(
          `https://countriesnow.space/api/v0.1/countries/state/cities`,
          payload
        )
        .then((response) => {
          this.cityItems = response.data.data;
          console.log(this.cityItems);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.storeId;
      await axios
        .get(`/stores/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.form.user_ids = [];
          console.log("form", this.form);
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.form.users.forEach((e) => {
        this.form.user_ids.push(e.id);
      });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        this.form.store_users = [];
        this.form.user_ids.forEach((user_id) => {
          let store_user = {
            company_id: this.company.id,
            user_id: user_id,
          };
          this.form.store_users.push(store_user);
        });
        console.log(this.form);
        await axios.patch(`/stores/${this.$route.params.storeId}`, this.form);
        await this.saveUserTimestamp(this.old_json, this.form);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
    async saveUserTimestamp() {
      try {
        let form = {
          from_path: `/stores/${this.form.id}`,
          from_name: "StoresEditPage",
          user_id: this.user.id,
          old_json: JSON.stringify(this.old_json),
          new_json: JSON.stringify(this.form),
        };
        await axios.post(`/user_timestamps`, form);
        this.$router.push("/stores");
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
